import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const squadData = createAsyncThunk(
  "getsquadData",
  async (IdandStatus) => {
    console.log(IdandStatus);
    if (IdandStatus.match_status === "Upcoming") {
      try {
        var { data } = await axios({
          method: "post",
          url: "https://api.cricway.live/api/v1/matchInfo/getPlayersByMatchId/asjgs55463",
          data: {
            param: IdandStatus.match_id,
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=utf-8",
          },
        });
        return data;
      } catch (err) {
        return err;
      }
    } else {
      try {
        var { data } = await axios({
          method: "post",
          url: "https://api.cricway.live/api/v1/matchInfo/getSquadByMatchId/asjgs55463",
          data: {
            param: IdandStatus.match_id,
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=utf-8",
          },
        });
        return data;
      } catch (err) {
        return err;
      }
    }
  }
);

const squadSlice = createSlice({
  name: "squad",
  initialState: {
    data: [],
    pending: false,
    error: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(squadData.pending, (state) => {
        state.pending = true;
      })
      .addCase(squadData.fulfilled, (state, action) => {
        state.pending = false;
        state.data = action.payload;
        state.error = false;
      })
      .addCase(squadData.rejected, (state, action) => {
        state.pending = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});

export default squadSlice.reducer;
